<template>
  <div class="lookVideo">
    <div v-if="showTitle" class="home-channel_title home-channel-xl_title"><div class="title-inner">实时视频</div></div>
    <div class="lookVideo-content"
    :class="{
      'padding-0': hidePadding
    }"
    >
      <div class="info-wrapper" v-if="showAddress">
        <div class="address"> {{ videoDialog.address }}</div>
        <div class="footer-one-button">
          <el-button size="small" @click="handleCloseVideo"><i class="el-icon-switch-button"></i></el-button>
<!--          <el-button size="small" @click="handleFullScreen"><i class="el-icon-full-screen"></i></el-button>-->
        </div>
      </div>
      <div v-if="linkcvrArry.includes(videoDialog.cvrSign)">
        <div v-loading="videoDialog.loading" element-loading-text="获取视频中..." style="min-height: 400px">
          <devicePlayer ref="devicePlayerRef" id="qureyPlayer1"></devicePlayer>
        </div>
      </div>
      <div v-if="videoDialog.cvrSign == 'Easycvr'">
        <div v-loading="videoDialog.loading" element-loading-text="获取视频中..." style="min-height: 400px">
          <div id="videoPlayer"></div>
        </div>
      </div>
      <div v-if="videoDialog.cvrSign == 'LVC'">
        <div element-loading-background="rgba(0,0,0,1)"
             v-loading="videoDialog.loading" element-loading-text="获取视频中..." style="height: 400px">
          <video id="video" controls="" preload="" height="100%" width="100%" src=""></video>
        </div>
      </div>
      <div v-if="videoDialog.cvrSign === 'LIS'">
        <div style="height: 400px">
          <h-k-video-player ref="hkVideoPlayer" @live-stop-success="handleLiveStop" :player-height="videoHeight"/>
        </div>
      </div>
      <div v-if="videoDialog.cvrSign === 'LVS'">
        <div v-loading="videoDialog.loading" element-loading-text="获取视频中..." style="height: 400px">
          <HKvideo ref="HKvideo" :hkOptions="hkOptions"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import devicePlayer from "@/pages/transferView/devicePlayer.vue";
import HKvideo from "@/components/HKvideo.vue";
import DirectionalButtons from "@/components/DirectionalButtons.vue";
import HKVideoPlayer from "@/components/HKVideoPlayer.vue";

export default {
  components: {HKVideoPlayer, DirectionalButtons, HKvideo, devicePlayer},
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    showAddress: {
      type: Boolean,
      default: true
    },
    windowClose: {
      type: Boolean,
      default: false
    },
    hidePadding: {
      type: Boolean,
      default: false
    },
    videoHeight: {
      type: String,
      default: '400'
    }
  },
  data(){
      return {
        address: '',
        hkOptions: {
          type: 2,
          ip: '',//海康威视摄像头/硬盘录像机的服务器IP
          port: '',//海康威视摄像头/硬盘录像机的端口
          iWSPort: '',//海康威视摄像头/ws端口号
          username: '',//海康威视摄像头/硬盘录像机的用户名
          password: '',//海康威视摄像头/硬盘录像机的密码
          rtspUrl: '', // 不为空时 使用rtsp预览
        },
        videoDialog: {
          cvrSign: "",
          loading: false,
          address: "",
          timer: "",
          player: "",
          url: "", //easyCvr的视频流
        },
        platform: '',
        linkcvrArry: ['Linkcvr', 'Linkcvr0', 'Linkcvr1', 'Linkcvr2']
      }
  },
  beforeDestroy () {
    this.closeVideo()
  },
  methods:{
    look(row) {
      this.$refs.HKvideo && this.$refs.HKvideo.clickLogout()
      this.$refs.hkVideoPlayer && this.$refs.hkVideoPlayer.stop()
      this.hkOptions = {}
      this.videoDialog.cvrSign = row.platform;
      this.videoDialog.loading = true;
      this.videoDialog.address = row.address1;
      this.videoDialog.uuid = row.uuid
      this.videoDialog.channelId = row.cvrChannel
      this.videoDialog.cameraType = row.cameraType
      this.platform = row.platform
      if (this.linkcvrArry.includes(row.platform)) {
        let deviceId = row.gbDeviceID;
        let channelId = row.cvrChannel;

        if (row.platform === "Linkcvr" || row.platform === "Linkcvr0" || row.platform === "Linkcvr1") {
          channelId = row.gbCodeID;
        }

        if (!deviceId) {
          this.$message.error("该设备的gbDeviceID为null");
          return;
        }
        if (!channelId) {
          this.$message.error("该设备的gbCodeID为null");
          return;
        }
        $.ajax({
          url: `https://www.00e.com/apis/webapi/probeEquipment/play?deviceId=${deviceId}&channelId=${channelId}&platform=${row.platform}`,
          type: "get",
          dataType: "json",
        })
          .done((resp) => {
            this.videoDialog.loading = false;
            if (resp.code === 0) {
              this.$refs.devicePlayerRef.openDialog("media", deviceId, channelId, {
                streamInfo: resp.data,
                hasAudio: true,
              });
            } else {
              this.$message.error(resp.msg);
            }
          })
          .fail(() => {
            this.$message.error("视频获取失败！");
            this.videoDialog.loading = false;
          });
      } else if (row.platform === "Easycvr") {
        if (this.videoDialog.timer) {
          //清除定时器
          clearInterval(this.videoDialog.timer);
        }
        //停流
        if (this.videoDialog.player) {
          this.videoDialog.player.destroy(this.videoDialog.url);
        }

        let sign = 1;

        let success = function (resp) {
          sign++;
          if (sign - 2 < 1) {
            this.videoDialog.loading = false;
            this.videoDialog.url = resp.url;

            this.videoDialog.player = new WasmPlayer(null, "videoPlayer");
            this.videoDialog.player.play(resp.url, 1);
          }
        };
        this.http.post(
          "/webapi/probeEquipment/inLine",
          {
            id: row.id,
          },
          success
        );
        this.videoDialog.timer = setInterval(() => {
          this.http.post(
            "/webapi/probeEquipment/inLine",
            {
              id: row.id,
            },
            success
          );
        }, 15 * 1000);
      } else if (row.platform === "LVC") {
        //获取视频流
        let submitData = {
          id: row.pid,
        };
        try {
          this.http.get("/webapi/lvcProbe/trustPlayer", submitData, (resp) => {
            if (resp.mp4) {
              this.plyerUrl = resp.mp4;
              this.videoDialog.loading = false;
              if (this.plyerUrl) {
                $("#video").attr("src", this.plyerUrl);
              }
            } else {
              this.videoDialog.loading = false;
              this.$message.error("获取视频流失败！");
            }
          });
        } catch (e) {
          console.log(e)
        }

      } else if (row.platform === "LVS") {
        this.hkOptions.ip = row.lvsIpAddress
        this.hkOptions.port = row.lvsHttpPort
        this.hkOptions.iWSPort = row.lvsWebsocketPort
        this.hkOptions.username = row.username
        this.hkOptions.password = row.password
        this.hkOptions.rtspUrl = ''
        this.videoDialog.loading = false
        this.$nextTick(() => {
          this.$refs.HKvideo.init()
        })
      } else if (row.platform === "LIS") {
        this.http.get("/webapi/probeEquipment/lis/play", {
          uuid: row.uuid,
          channelId: row.cvrChannel,
        }, ({ data }) => {
          if (!data) {
            console.error('设备信息错误')
            return
          }
          this.videoDialog.loading = false
          // cvrSign 刚从旧值变为 "LIS"，hkVideoPlayer 由 v-if 控制，
          // 需等 DOM 渲染完成后 ref 才存在，用双重 nextTick + 重试保证
          const startPlay = () => {
            if (this.$refs.hkVideoPlayer) {
              this.$refs.hkVideoPlayer.start({
                previewUrl: data,
              })
            } else {
              setTimeout(startPlay, 50)
            }
          }
          this.$nextTick(() => {
            this.$nextTick(startPlay)
          })
        });
      }
    },
    handleFullScreen () {
      if (this.linkcvrArry.includes(this.videoDialog.cvrSign)) {
        this.$refs.devicePlayerRef.fullscreen()
        return
      }
      this.$refs.HKvideo.fullScreen()
    },
    handleCloseVideo () {
      if (this.windowClose) {
        window.close()
        return
      }
      this.closeVideo()
      this.$refs.HKvideo && this.$refs.HKvideo.clickLogout()
      this.$emit("closeVideo")
    },
    closeVideo() {
      if (this.videoDialog.cvrSign === "Linkcvr") {
        this.videoDialog.cvrSign = "";
      } else if (this.videoDialog.cvrSign === "Easycvr") {
        this.videoDialog.cvrSign = "";
        if (this.videoDialog.timer) {
          //停止定时器
          clearInterval(this.videoDialog.timer);
          //停流
          if (this.videoDialog.player) {
            this.videoDialog.player.destroy(this.videoDialog.url);
          }
        }
      } else if (this.videoDialog.cvrSign === "LVC") {
        let video = document.getElementById("video");
        if (video) {
          if (!video.paused) {
            video.load();
          }
          video.removeAttribute("src");
        }
      } else if (this.videoDialog.cvrSign === "LIS") {
        this.$refs.hkVideoPlayer && this.$refs.hkVideoPlayer.stop()
      } else if (this.videoDialog.cvrSign === "LVS") {
        this.$refs.HKvideo.clickLogout()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.lookVideo {
  margin-top: 12px;
  height: 700px;
  position: relative;
}
.button-wrap {
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.lookVideo-content {
  box-sizing: border-box;
  padding-top: 75px;
  height: calc(100% - 36px);
  background: #000;
  &.padding-0 {
    padding-top: 0;
    height: 100%;
  }
}
.info-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 16px;
  .address {
    font-size: 16px;
    font-weight: bold;
    color: #fff;
  }
}
.footer-one-button {
  display: flex;
  align-items: flex-end;
  padding: 6px 0;

  button {
    margin: 0 10px 0 0;
    padding: 3px;
    background: transparent;
    border: none;
  }

  i {
    font-size: 25px;
    color: #fff;
  }
}
</style>

<style lang="less">
.lookVideo {
  .transfer-close,.buttons-box {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lookVideo.vue